module.exports = __webpack_public_path__ + "static/media/frames-27.1289ac26.jpg";